<div class="grid">
    <div *ngIf="!showSearch && !report" class="col-fixed p-2 border-round-sm" style="width:30px;height:75vh;background-color: lightgray; margin-left: -13px; cursor: pointer;" (click)="showSearch = true">
        <i class="pi pi-chevron-right"></i>
        <div style="writing-mode: tb-rl;margin-left: -3px; margin-top: 20vh; font-size: 18px;">Search Criteria</div>
    </div>
    <div [style.width]="showSearch ? '450px' : '0px'" [style.height]="showSearch ? 'auto' : '1px'" [style.overflow]="showSearch ? 'visible' : 'hidden'" [style.visibility]="showSearch ? 'visible' : 'hidden'">
        <div class="grid" style="margin-top: 10px; margin-left: -8px;">
            <label class="col-fixed" style="font-size: large; width: 75px;">Crop</label>
            <p-dropdown class="col-7" [options]="crops" [(ngModel)]="selectedCrop" [filter]="true" optionLabel="Name" placeholder="Select" filterMatchMode="startsWith" (onChange)="onCropChange()" [style]="{'margin-top': '-5px'}" />
            <i *ngIf="rowData.length > 0" class="pi pi-times-circle" style="cursor: pointer; font-size: 20px; margin-top: 10px; color: darkgray;" (click)="showSearch = false"></i>
        </div>
        <div *ngIf="type==='usage'" style="margin-top: 15px; margin-left: 8px;">
            <div class="grid">
                <label style="font-size: large; width:75px;">Year</label>
                <ng-select data-toggle="tooltip" data-placement="top" title="Select year to search." [items]="years" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selYears">
                </ng-select>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="font-size: large; width:75px;">Program</label>
                <ng-select data-toggle="tooltip" data-placement="top" title="Select program to search." [items]="programs" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selPrograms">
                </ng-select>
            </div>
            <div class="grid" style="margin-top: 10px;">
                <label style="font-size: large; width:75px;">Stage</label>
                <ng-select data-toggle="tooltip" data-placement="top" title="Select stage to apply filter on search." [items]="stages" [multiple]=true [searchable]="true" [closeOnSelect]=false [markFirst]="true" [searchFn]="onNGSearch" placeholder="Select" [(ngModel)]="selStages"></ng-select>
            </div>
        </div>
        <div class="grid" *ngIf="type==='nursery'" style="margin-top: 15px; margin-left: 0px;">
            <label style="font-size: large; width:75px;">Program </label>
            <p-dropdown [options]="programs" [(ngModel)]="program" [filter]="true" placeholder="Select" filterMatchMode="startsWith" [style]="{'margin-top': '-5px'}" />
        </div>
        <div style="display: block;margin-top: 15px;">
            <label style="font-weight: bold;font-size: large;vertical-align: middle;"> Search By:</label>
            <span *ngIf="type == 'poprequest'">
                <p-radioButton value="DH Request Name" [(ngModel)]="searchBy" label="Request Name" />
                <p-radioButton value="DH Request ID" [(ngModel)]="searchBy" label="Request ID" />
            </span>
            <span [ngStyle]="type == 'poprequest' ? {'display': 'block' } : {'display': '' } ">
                <p-radioButton value="CVN" [(ngModel)]="searchBy" label="GE_Name" />
                <p-radioButton value="GE ID" label="GEID" [style]="{'margin-left': '5px'}" [(ngModel)]="searchBy" />
            </span>
            
            <label style="font-weight: bold; display: block; margin-bottom: 12px;margin-top: 5px;">Total Rows :
                {{idList.length}}</label>
            <span>
                <textarea style="max-height: 244px;" [rows]="10" [cols]="20" [autoResize]="true" [(ngModel)]="idListText" pInputTextarea></textarea>
            </span>
        </div> 
    </div>
    <div *ngIf="rowData.length > 0 && type!=='usage'" class="col">
        <ag-grid-angular id="agGrid"
            style="height: 73vh; width: 100%;" class="ag-theme-balham"  [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" 
            [animateRows]="true" [rowData]="rowData" [enableRangeSelection]=true
            [gridOptions]="gridOptions" [suppressRowClickSelection]="true" [statusBar]="statusBar" (gridReady)="onGridReady($event)"                      
            [animateRows]="true"></ag-grid-angular> 
    </div>
    <div *ngIf="type==='usage' && usageData" class="col">
        <p-tabMenu [model]="tabItems" [activeItem]="activeItem" (activeItemChange)="loadUsageTab($event)"></p-tabMenu>
        <ag-grid-angular id="agGrid" *ngIf="rowData.length > 0"
            style="height: 73vh; width: 100%;" class="ag-theme-balham"  [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" 
            [animateRows]="true" [rowData]="rowData" [enableRangeSelection]=true
            [gridOptions]="gridOptions" [suppressRowClickSelection]="true" [statusBar]="statusBar" (gridReady)="onGridReady($event)"                      
            [animateRows]="true"></ag-grid-angular>
    </div>
    <ag-grid-angular id="agGrid1" *ngIf="tab1RowData.length > 0"
        style="height: 0vh; width: 0%;" class="ag-theme-balham"  [columnDefs]="tab1ColDef" [defaultColDef]="defaultColDef" 
        [rowData]="tab1RowData" [gridOptions]="gridOptions" (gridReady)="onTab1GridReady($event)" ></ag-grid-angular>
    <ag-grid-angular id="agGrid2" *ngIf="tab2RowData.length > 0"
        style="height: 0vh; width: 0%;" class="ag-theme-balham"  [columnDefs]="tab2ColDef" [defaultColDef]="defaultColDef" 
        [rowData]="tab2RowData" [gridOptions]="gridOptions" (gridReady)="onTab2GridReady($event)" ></ag-grid-angular>
    <ag-grid-angular id="agGrid3" *ngIf="tab3RowData.length > 0"
        style="height: 0vh; width: 0%;" class="ag-theme-balham"  [columnDefs]="tab3ColDef" [defaultColDef]="defaultColDef" 
        [rowData]="tab3RowData" [gridOptions]="gridOptions" (gridReady)="onTab3GridReady($event)" ></ag-grid-angular>
    <ag-grid-angular id="agGrid4" *ngIf="tab4RowData.length > 0"
        style="height: 0vh; width: 0%;" class="ag-theme-balham"  [columnDefs]="tab4ColDef" [defaultColDef]="defaultColDef" 
        [rowData]="tab4RowData" [gridOptions]="gridOptions" (gridReady)="onTab4GridReady($event)" ></ag-grid-angular>
</div>
 
  
    
  